export const DragIcon = () => {
  return (
    <svg
      width="8"
      height="15"
      viewBox="0 0 8 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 2.82227H2V0.822266H0V2.82227ZM0 8.82227H2V6.82227H0V8.82227ZM0 14.8223H2V12.8223H0V14.8223ZM6 0.822266V2.82227H8V0.822266H6ZM6 8.82227H8V6.82227H6V8.82227ZM6 14.8223H8V12.8223H6V14.8223Z"
        fill="#7F94A9"
      />
    </svg>
  );
};

export const VisibleIcon = () => {
  return (
    <svg
      width="19"
      height="14"
      viewBox="0 0 19 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18 7.00017C16.5151 10.0655 12.7959 13 9.4998 13C6.20371 13 2.48449 10.0655 1 6.99981"
        stroke="#C6D4E1"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18 7.00017C16.5151 3.93484 12.7965 1 9.50039 1C6.2043 1 2.48449 3.93412 1 6.99981"
        stroke="#C6D4E1"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.05 7C12.05 8.42016 10.9083 9.57143 9.5 9.57143C8.09167 9.57143 6.95 8.42016 6.95 7C6.95 5.57984 8.09167 4.42857 9.5 4.42857C10.9083 4.42857 12.05 5.57984 12.05 7Z"
        stroke="#C6D4E1"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const InivisbleIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.87727 3.3562C8.40917 3.23903 8.95373 3.18045 9.5 3.18166C14.9091 3.18166 18 8.99984 18 8.99984C17.5309 9.82574 16.9715 10.6033 16.3309 11.3198M11.1382 10.5417C10.926 10.756 10.67 10.928 10.3857 11.0472C10.1013 11.1665 9.79433 11.2306 9.48307 11.2357C9.17181 11.2409 8.86263 11.187 8.57397 11.0773C8.28532 10.9676 8.0231 10.8042 7.80297 10.597C7.58284 10.3899 7.4093 10.1431 7.29271 9.8714C7.17612 9.59972 7.11886 9.30873 7.12435 9.01577C7.12984 8.72282 7.19797 8.43391 7.32468 8.16628C7.45138 7.89864 7.63406 7.65777 7.86182 7.45802M14.09 13.3198C12.7691 14.2675 11.1607 14.7925 9.5 14.818C4.09091 14.818 1 8.99984 1 8.99984C1.96119 7.31395 3.29433 5.84101 4.91 4.67984L14.09 13.3198Z"
        stroke="#C6D4E1"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1 1L18 17"
        stroke="#C6D4E1"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const GeneralIcon = () => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.6579 0.89917C16.3991 0.89917 17 1.50005 17 2.24128V12.9781C17 13.7193 16.3991 14.3202 15.6579 14.3202H12.5263V16.5571C12.5263 17.2983 11.9254 17.8992 11.1842 17.8992H1.34211C0.600881 17.8992 0 17.2983 0 16.5571V6.71496C0 5.97373 0.600881 5.37285 1.34211 5.37285H3.57895V2.24128C3.57895 1.50005 4.17983 0.89917 4.92105 0.89917H15.6579ZM9.8421 12.5307H15.2105V7.16233L9.8421 12.5307ZM1.78947 16.1097H10.7368V14.2965L4.92549 14.3158C4.18254 14.3182 3.57895 13.7166 3.57895 12.9737V7.16233H1.78947V16.1097ZM10.7368 2.68864H5.36842V8.05706L10.7368 2.68864Z"
        fill="#000729"
      />
    </svg>
  );
};

export const StylesIcon = () => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.125 7.19917L13.525 1.59917C12.825 0.89917 11.725 0.89917 11.025 1.59917L5.425 7.19917C4.725 7.89917 4.725 8.99917 5.425 9.69917L11.025 15.2992C11.325 15.5992 11.825 15.7992 12.225 15.7992C12.625 15.7992 13.125 15.5992 13.425 15.2992L19.025 9.69917C19.825 8.99917 19.825 7.79917 19.125 7.19917ZM1.525 8.19917L7.825 1.89917L6.825 0.89917L0.525 7.19917C-0.175 7.89917 -0.175 8.99917 0.525 9.69917L6.825 15.8992L7.925 14.7992L1.625 8.49917C1.425 8.49917 1.425 8.29917 1.525 8.19917Z"
        fill="#000729"
      />
    </svg>
  );
};
